<template>
  <div :style="{height:'100%'}">
    <vue-header title="面诊" isReturn="true"/>
    <camera :type="type"/>
  </div>
</template>
<script>
  import vueHeader from "@/components/header";
  import camera from "@/components/camera";
  export default {
    name: "step1",
    components: {
      vueHeader,
      camera
    },
    data(){
      return{
          type:1
      }
    },
    created:function(){
        let flow = sessionStorage.getItem('flow');
        if(flow){
          let flow_step = JSON.parse(flow).flow_info.flow_step;
          if(flow_step==17){
            this.type = 5;
          }
        }
    },
  };
</script>